// import 'core-js/stable'
// import 'regenerator-runtime/runtime'

import jQuery from 'lib/jquery' // only for
import './layout'
import 'lib/detect-interaction'
import './controllers'
import './lib/conversion/emit-page-view-event'

function idempotentFoundationInit () {
  if (globalThis.foundationInitialized) return
  jQuery(document).foundation()
  globalThis.foundationInitialized = true
}

function initFoundationMaybe () {
  if (globalThis.skipFoundation) return

  idempotentFoundationInit()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFoundationMaybe)
} else {
  setTimeout(initFoundationMaybe, 0)
}

export { idempotentFoundationInit, initFoundationMaybe }
export * from './lib/foundation-base'
export { default as App } from './app'
export { default as PageBase } from 'lib/page-base'
export { default as stimulus } from 'lib/stimulus-instance'
export * from 'lib/query-selector'
